import { useThemeContext } from "./ThemeProvider.provider";

export function useButtonVariant() {
  const { buttonVariant } = useThemeContext();
  return buttonVariant;
}
